import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/types/store';

/**
 * @param {object} state
 * @returns {object}
 */

export const getAppState = createSelector([({ app }: RootState) => app], app => ({
  navigation: app?.dictionary?.navigation || [],
  partners: app?.dictionary?.partners || [],
  dictionaryLoading: app?.loadings?.dictionary || false,
}));

export default {
  getAppState,
};
